<template>
  <div class="intro__card">
    <div class="intro__header">
      <div class="intro__header_logo_row">
        <img
          class="intro__header_logo"
          src="@/assets/img/max_box_red_outline.png"
          alt=""
        />
      </div>
      <!-- <p class="intro__title">
                {{$t('Simulador constálica')}}
            </p> -->

      <p class="intro__subtitle">
        {{ $t("Encontre a solução ideal para o seu projecto") }}
      </p>
    </div>

    <div class="intro__body">
      <p
        class="intro__p"
        v-html="$t('Seja bem vindo ao simulador <b>Maxbox</b>,')"
      ></p>

      <p
        class="intro__p"
        v-html="
          $t(
            'Aqui poderá efectuar o dimensionamento estrutural com produtos Madremax<sup>&reg;</sup> e Omegamax<sup>&reg;</sup>.<br>O simulador efetua todas as verificações de segurança necessárias, permitindo a exportação de notas de cálculo detalhadas e o seu armazenamento na conta de utilizador.'
          )
        "
      ></p>

      <p class="intro__p u-fwb">
        {{ $t("Instruções:") }}
      </p>

      <ul class="intro__list">
        <li class="intro__list_item">
          {{
            $t(
              "Durante a simulação por favor insira todos os campos que sejam relevantes para a sua obra;"
            )
          }}
        </li>
        <li class="intro__list_item">
          {{
            $t(
              "Alguns campos permitem a inserção de valores únicos para cada vão;"
            )
          }}
        </li>
        <li class="intro__list_item">
          {{
            $t(
              "Em caso de dúvida, alguns campos contêm instruções e explicações sobre os mesmos;"
            )
          }}
        </li>
      </ul>
    </div>

    <div class="intro__footer">
      <p class="intro__p">
        {{
          $t("Estaremos à sua disposição para responder a qualquer questão.")
        }}
      </p>
      <p class="intro__p">
        {{ $t("Obrigado.") }}
      </p>

      <div class="intro__footer_logo_row">
        <img
          class="intro__footer_logo"
          src="@/assets/img/logo_constalica.png"
          alt=""
        />
      </div>
    </div>

    <ul class="intro__lang_select">
      <span
        class="intro__lang_option"
        @click="handleLangClick(lang)"
        :class="selectedLang === lang ? 'is-active' : ''"
        v-for="lang in langs"
        :key="lang"
        >{{ lang.toUpperCase() }}</span
      >
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { debounce } from "@/utils";
import { langsIdxs } from "@/i18n";

export default {
  data() {
    return {
      //ref langs idx $t.js
      langs: ["pt", ...Object.keys(langsIdxs)],
    };
  },

  computed: {
    ...mapState(["selectedLang", "user"]),

    isCalculator() {
      return this.$route.name === "Calculator";
    },
  },

  methods: {
    ...mapActions(["updateAccount", "updateSelectedLang", "setHasSeenIntro"]),

    debouncedUpdateUser: debounce(function ({ lang }) {
      this.user && this.updateAccount({ lang });
    }, 5000),

    handleLangClick(lang) {
      this.updateSelectedLang(lang);
      this.debouncedUpdateUser({ lang });
    },
  },

  mounted() {
    this.setHasSeenIntro(true);
  },
};
</script>

<style lang="scss" scoped>
.intro__card {
  position: relative;
  background-color: #fff;
  color: #000;
  padding: 64px 200px 64px 129px;
  max-width: 944px;
  margin: auto;
}
.intro__header {
  margin-bottom: 2em;
}

.intro__header_logo {
  height: 60px;
}

.intro__title,
.intro__subtitle {
  font-family: $font-family-title;
  font-weight: bold;
  letter-spacing: 0.7px;
  text-transform: uppercase;
}

.intro__title {
  font-size: 38px;
  line-height: 58px;
}

.intro__subtitle {
  font-size: 20px;
  line-height: 30px;
}

.intro__body {
  margin-bottom: 2em;
}

.intro__p {
  margin-bottom: 1em;
}

.intro__list_item:before {
  content: "—";
  margin-right: 0.5em;
}

.intro__footer_logo {
  width: 105px;
}

.intro__lang_select {
  position: absolute;
  bottom: 13px;
  right: 24px;
  display: flex;
}

.intro__lang_option {
  font-family: $font-family-title;
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  letter-spacing: 0.7px;
  text-decoration-line: underline;
  text-transform: uppercase;
  margin-left: 0.5em;
  cursor: pointer;
}

.intro__lang_option.is-active  {
  color: #111;
}
</style>
